import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
} from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { WebView } from 'react-native-webview';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';

function ZendeskSectionPage() {
  const { id, title } =
    useLocalSearchParams<{
      id: string;
      title: string;
    }>() ?? {};

  return (
    <View style={styles.webview}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: title,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <WebView
        source={{
          uri: `https://support.varomoney.com/hc/en-us/sections/${id}`,
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  webview: {
    flex: 1,
  },
});

export default ZendeskSectionPage;
